export default __webpack_public_path__ + "static/media/mute.9dcadbb6.png";